/**
 * Add to calendar (Phase 4). Primary action opens the Outlook web compose deep link in a
 * new tab; the .ics download is the fallback if that deep link misbehaves for this tenant.
 * Both omit a time — the reviewer sets it manually.
 */
import type { MouseEvent } from 'react';
import { buildCalendarLink, buildCalendarIcs } from '../../reviewer/calendar';

interface AddToCalendarProps {
  reportId: string;
  addressRaw: string | null;
  valuerName: string;
}

export function AddToCalendar({ reportId, addressRaw, valuerName }: AddToCalendarProps) {
  function openDeepLink(e: MouseEvent) {
    e.stopPropagation();
    window.open(buildCalendarLink(addressRaw, valuerName), '_blank', 'noopener,noreferrer');
  }

  function downloadIcs(e: MouseEvent) {
    e.stopPropagation();
    const { filename, content } = buildCalendarIcs(reportId, addressRaw, valuerName);
    const url = URL.createObjectURL(new Blob([content], { type: 'text/calendar;charset=utf-8' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  }

  return (
    <span className="add-to-calendar" onClick={(e) => e.stopPropagation()}>
      <button type="button" className="btn btn--secondary btn--sm" onClick={openDeepLink}>
        Add to calendar
      </button>
      <button type="button" className="add-to-calendar__ics" onClick={downloadIcs}>
        .ics
      </button>
    </span>
  );
}
